import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import OfferCard from "../../components/cards/OfferCard/OfferCard";
import offersData from "../../data/offersData";
import './OffersPage.css';
import AftersalesSupportSection from "../../components/sections/AftersalesSupportSection/AftersalesSupportSection";

export default function SparePartsPage() {

    
    return (
        <div className="Page">
            <div className="offersPageBanner text-center">
                <div className="page-banner-content">
                    <h3>
                        Offers
                    </h3>
                    <h1>
                        Make Competitors Sweat
                    </h1>
                </div>
            </div>

            <Container fluid>
                <div className="section-spacing">
                    <p class="brand-section-desc text-center mb-0">Get your LandKing at the Offers that makes the competitor think twice to offer.</p>
                </div>

                
            </Container>

            <div className="section-spacing-top">
                <AftersalesSupportSection />
            </div>
        </div>
    );
}